import * as dashboardSelectors from '@/dashboard/dashboard-selectors';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { UniversalSearchDrawer } from './universal-search-drawer';

export function AsyncUniversalSearchDrawer() {
  const isUniversalSearchActive = useSelector(
    dashboardSelectors.isUniversalSearchActive
  );

  return (
    <Suspense fallback={<div />}>
      <UniversalSearchDrawer
        isUniversalSearchActive={isUniversalSearchActive}
      />
    </Suspense>
  );
}
